import { StyledFloorSelectorControlDiv } from '../Styled';
import useMap from '../hooks/useMap';
import { observer } from 'mobx-react';
import { useMapStore } from 'contexts/RootStore.context';
import { DomEvent } from 'leaflet';

// determine levels associated with buildings by filtering matching building_ids in levels.geojson.
// each feature returned represents a level or floor for that building
// we then filter the features by unique ordinals,
// sort them numerically,
// loop over sorted levels and render a button only if building has multiple unique ordinals.
export const FloorSelectorControl = observer(() => {

  const { selectedBuildingOrdinals, selectedFloor, selectFloor, selectedBuildingId, getOrdinalLevels } = useMapStore()
  const { fitMapToBoundsOfGeoJSON } = useMap(useMapStore());

  function handleFloorSelect(ev: React.SyntheticEvent, ordinal: number) {
    ev.preventDefault();
    // prevent clicks and double clicks propagating & causing zooms.
    DomEvent.disableClickPropagation(ev.target as any);

    if (selectedBuildingId) {
      selectFloor(ordinal)
      // center map to feature bounds of selected floor.
      fitMapToBoundsOfGeoJSON(getOrdinalLevels(selectedBuildingId, ordinal));
    }
  }

  return (
    <StyledFloorSelectorControlDiv id="floor-selector">
      {selectedBuildingOrdinals.map(ordinal => {
        // render a button for each unique ordinal.
        const floorIsSelected = selectedFloor === ordinal;

        return (
          <div className="button-container" key={ordinal}>
            <button
              id={`floor-button-${ordinal}`}
              className={floorIsSelected ? '--active' : ''}
              onClick={(ev) => handleFloorSelect(ev, ordinal)}
            >
              {ordinal}
              {/* <FloorCountBadge ordinal={ordinal} /> */}
            </button>
          </div>
        );
      })}
    </StyledFloorSelectorControlDiv>
  );
})
